import { getCookie } from '@shared/cookie';
import LocalTracking from '@shared/tracking-local';
import { qtsHttpEndpoint } from 'server-data/tracking';
import { cookieBase, languageCode, cookieDomain } from 'server-data/flconfigs';
import QTSTracking from './qtslib';

_t = new QTSTracking(
  `${qtsHttpEndpoint}1px.gif`,
  cookieDomain,
  { user_id: getCookie(`${cookieBase}_USER_ID`) },
).init(_t);

_lt = new LocalTracking().init(_lt);

// Page view event
_t.push(['page_view', {
  screenHeight: window.screen.height,
  screenWidth: window.screen.width,
  windowInnerHeight: window.innerHeight,
  windowInnerWidth: window.innerWidth,
  language: languageCode,
}]);

if (window.performance && window.performance.mark) {
  window.performance.mark('qts_ready');
}
